/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Mistakestypehanziwriting3Inputs */

const zh_learn_mistakestypehanziwriting3 = /** @type {(inputs: Learn_Mistakestypehanziwriting3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`汉字书写`)
};

const en_learn_mistakestypehanziwriting3 = /** @type {(inputs: Learn_Mistakestypehanziwriting3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanzi Writing`)
};

const es_learn_mistakestypehanziwriting3 = /** @type {(inputs: Learn_Mistakestypehanziwriting3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escritura de hanzi`)
};

/**
* | output |
* | --- |
* | "Hanzi Writing" |
*
* @param {Learn_Mistakestypehanziwriting3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_mistakestypehanziwriting3 = /** @type {((inputs?: Learn_Mistakestypehanziwriting3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Mistakestypehanziwriting3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_mistakestypehanziwriting3(inputs)
	if (locale === "en") return en_learn_mistakestypehanziwriting3(inputs)
	return es_learn_mistakestypehanziwriting3(inputs)
});
export { learn_mistakestypehanziwriting3 as "learn_mistakesTypeHanziWriting" }